import React from 'react';
import { Segment, Divider, Table, Button, Icon, Modal } from 'semantic-ui-react';
import { UserActions } from '../../actions';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import {showCertificate} from './';
class Onay extends React.Component {
    constructor(props) {
        super(props);
        let uCertificates = this.props.uCertificates;
        if (uCertificates.length == 0) {
            this.props.dispatch(UserActions.get_ucertificates());        
        }
        this.openPopup = this.openPopup.bind(this);
        this.cancel = this.cancel.bind(this);
        this.confirm = this.confirm.bind(this);
    }
    openPopup(index){
        if (this.props.certificateDetails != [] && this.props.uCertificates[index].DriverId && this.props.uCertificates[index].Certificate){
            this.props.dispatch(UserActions.get_ucertificate(this.props.uCertificates[index].DriverId, this.props.uCertificates[index].Certificate));
        }       
    }
    
    confirm(driverId, certificate,index) {
        this.props.dispatch(
            UserActions.confirm_certificate(driverId,certificate, index)
        );     
    }
    cancel(driverId, certificate, index) {
        this.props.dispatch(
            UserActions.delete_certificate(driverId, certificate, index)
        );
    }
    render() {
        return (
            <div>
                <Segment id='Egitimler' style={{ height: '50%' }}>
                    <div className='panel-pages-top' >
                        <h1 id='Egitimler'>Onay</h1>
                    </div>
                    <Divider />
                    <Segment id='Egitimler-ic'>
                        <Table id='antiSkid' textAlign='center' style={{ background: 'rgba(255,255,255,0.12)' }}>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Lisans No</Table.HeaderCell>
                                    <Table.HeaderCell>Ad</Table.HeaderCell>
                                    <Table.HeaderCell>Soyad</Table.HeaderCell>
                                    <Table.HeaderCell>Sertifika Adi</Table.HeaderCell>
                                    <Table.HeaderCell>Sertifika Tarihi</Table.HeaderCell>
                                    <Table.HeaderCell>Puan</Table.HeaderCell>
                                    <Table.HeaderCell>Goruntule</Table.HeaderCell>
                                    <Table.HeaderCell>Onayla</Table.HeaderCell>
                                    <Table.HeaderCell>Iptal Et</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                
                                {this.props.uCertificatesExist && tableElements.bind(this)()}
                                
                                <Table.Row>

                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </Segment>
                </Segment>
            </div>
        );
    }
}
function tableElements() {
    let a = this.props.uCertificates;
    return a.map((selection,index) => (
        <Table.Row key = {index}>
            <Table.Cell>{selection.LicenceNo}</Table.Cell>
            <Table.Cell>{selection.Name}</Table.Cell>
            <Table.Cell>{selection.Surname}</Table.Cell>
            <Table.Cell>{selection.Certificate}</Table.Cell>
            <Table.Cell><Moment unix format="DD/MM/YYYY">{selection.EvaluationDate/1000}</Moment></Table.Cell>
            <Table.Cell>{selection.TotalPoint}</Table.Cell>
            <Table.Cell>{showCertificate.bind(this)(index, this.props.uCertificates[index].Certificate)}</Table.Cell>
            <Table.Cell><Button id='Onay' onClick={() => { this.confirm(selection.DriverId, selection.Certificate, index)}} icon><Icon name='check' /></Button></Table.Cell>
            <Table.Cell><Button id='Onay' onClick={() => {this.cancel(selection.DriverId, selection.Certificate, index)}} icon><Icon name='cancel' /></Button></Table.Cell>
        </Table.Row>
    ));
}

function mapStateToProps(state) {
    const { uCertificates, uCertificatesExist, uCertificatesLoading, uCertificatesErr } = state.get_unconfirmed;
    const {certificateDetails, detailsExists, detailsLoading} = state.certificateDetails;
    return {
        uCertificates, 
        uCertificatesExist, 
        uCertificatesLoading, 
        uCertificatesErr,
        certificateDetails, 
        detailsExists,
        detailsLoading,
           
    };
}
const connectedConfirm = connect(mapStateToProps)(Onay);
export { connectedConfirm as Onay }; 


// WEBPACK FOOTER //
// ./src/components/PanelPages/Onay.jsx